import { DEFAULT_VIEW_ID } from '@gem-sdk/heatmap-react';
import { create } from 'zustand';

export interface IHeatmapMetaPayload {
  clickRankSearchQuery?: string;
}

interface IHeatmapMetaState {
  data: Map<string, IHeatmapMetaPayload>;
  rankQuery: Map<string, string>;
}

interface IHeatmapMetaActions {
  setMeta: <K extends keyof IHeatmapMetaPayload>(
    key: K,
    value: IHeatmapMetaPayload[K],
    viewId?: string,
  ) => void;
  getMeta: <K extends keyof IHeatmapMetaPayload>(key: K, viewId?: string) => IHeatmapMetaPayload[K];
  setRankQuery: (query: string, viewId?: string) => void;
  clearView: (viewId: string) => void;
  resetAll: () => void;
}

export interface IHeatmapMetaStore extends IHeatmapMetaState, IHeatmapMetaActions {}

const initialState: IHeatmapMetaState = {
  data: new Map(),
  rankQuery: new Map(),
};

export const useHeatmapMetaStore = create<IHeatmapMetaStore>()((set, get) => ({
  ...initialState,

  setRankQuery: (query, viewId = DEFAULT_VIEW_ID) => {
    const newData = new Map(get().rankQuery);
    newData.set(viewId, query);
    set({ rankQuery: newData });
  },

  setMeta: (key, value, viewId = DEFAULT_VIEW_ID) => {
    const currentData = get().data.get(viewId) ?? {};
    const newData = new Map(get().data);
    newData.set(viewId, { ...currentData, [key]: value });
    set({ data: newData });
  },

  getMeta: (key, viewId = DEFAULT_VIEW_ID) => {
    return get().data.get(viewId)?.[key];
  },

  clearView: (viewId) =>
    set((prev) => {
      const newData = new Map(prev.data);
      newData.delete(viewId);
      return { data: newData };
    }),

  resetAll: () => set({ data: new Map() }),
}));
